import { viewportActions } from '@starflow/app/store';
import { Text, TextEditToolbar, TextEditInput } from '@shakkerai/pro-atoms';
import helpers from '@starflow/app/helpers';
import { translate } from '@shakkerai/util-i18n';

const insertText = ({ x, y }, { autoFocus = false } = {}) => {
  const elementId = helpers.canvas.insertElement({
    type: 'text',
    x,
    y,
    width: 100,
    height: 18,
    data: {
      text: translate('tool_t_placeholer'),
      color: '#000000',
      fontSize: 138,
      fontFamily: 'Arial',
      fontStyle: '400',
    },
  });

  helpers.canvas.updateSelection([elementId]);

  // viewport相关操作的后面也会转到helpers里面去
  autoFocus && viewportActions.locateElement(elementId, { animate: true });
};

export default {
  setup: ({ app }) => {
    app.extension.registerElement('text', {
      element: Text,
      overlayer: TextEditInput,
      toolbar: TextEditToolbar,
      tool: {
        icon: 'shk-wenzi',
        label: 'Text',
        cursor: 'text',
        hotkey: 't',
        tooltip: translate('tool_text'),
        handler: ({ position }) => {
          insertText(position);

          // 这里return true可以在插入文字后退出文字模式tool
          return true;
        },
      },
      config: {
        rotateEnabled: true,
        keepRatio: true,
      },
    });
  },
};
